export class Session {
  constructor(public accessToken: string, public refreshToken: string) {
  }
}
